import React from 'react';
import { OptionColor } from 'ui/common/select/option/option-color';
import { OptionIcon } from 'ui/common/select/option/option-icon';

import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { renderLine } from 'app/area/shared/codetable/list-item/list-item-lines';
import { HierarchyMetadata } from 'app/area/shared/codetable/list-item/types';

import { linkCodesAction, LinkCodesActionType, LinkCodesTranslation } from '../constants';
import { ListBranchItem } from '../types-store';
import { ListItemCheckbox } from './list-item-checkbox';

import styles from './list-item-content.scss';

interface ListItemContentProps {
  item: ListBranchItem;
  path: number[];
  checked: boolean;
  hierarchyMode: boolean;
  hierarchyMetadata: HierarchyMetadata[];
  addAction: (path: number[], type: LinkCodesActionType, propagate: boolean) => void;
  translation: LinkCodesTranslation;
}

export const ListItemContent = ({
  item, path, checked, hierarchyMode, hierarchyMetadata, addAction, translation
}: ListItemContentProps) => {

  const onChange = () => {
    addAction(path, checked ? linkCodesAction.deselect : linkCodesAction.select, checked);
  };

  const contentClass = !hierarchyMode ? styles.content : styles.hierarchyContent;

  return <>
    {hierarchyMode && renderLine(hierarchyMetadata, path.length - 1)}
    <div className={contentClass}>
      <div className={styles.leftSide}>
        <ListItemCheckbox
          id={item.id}
          checked={checked}
          onChange={onChange} />
        {item.icon ? <OptionIcon iconUrl={toAbsoluteUrl(item.icon)} /> : null}
        {isDefinedIncludingZero(item.colour) ? <OptionColor color={item.colour} /> : null}
        <span>
          {item.description}
        </span>
      </div>
      <div className={styles.rightSide}>
        {(isDisabled(item.disabled) || (!!item.node && isDisabled(item.node.disabled))) && <Tag>
          {translation.disabled}
        </Tag>}
      </div>
    </div>
  </>;
};
